var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vch-my-wishlist-all-prodcuts"},[_c('div',{staticClass:"vch-grid"},[_c('div',{staticClass:"vch-col-offset-md-3 vch-col-12 vch-col-md-10 vch-col-offset-md-1 vch-col-lg-10 vch-col-offset-lg-2 vch-col-xl-6 vch-col-offset-xl-3"},[_c('vch-filter-list')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }